// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AdminTabsController from "./admin_tabs_controller"
application.register("admin-tabs", AdminTabsController)

import AutoSubmitController from "./auto_submit_controller"
application.register("auto-submit", AutoSubmitController)

import BulkActionsController from "./bulk_actions_controller"
application.register("bulk-actions", BulkActionsController)

import FormValidationController from "./form_validation_controller"
application.register("form-validation", FormValidationController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import MapPickerController from "./map_picker_controller"
application.register("map-picker", MapPickerController)

import SortableController from "./sortable_controller"
application.register("sortable", SortableController)

import ToastController from "./toast_controller"
application.register("toast", ToastController)

import DocumentUploadController from "./document_upload_controller"
application.register("document-upload", DocumentUploadController)

import ToggleController from "./toggle_controller"
application.register("toggle", ToggleController)

import RadioSelectController from "./radio_select_controller"
application.register("radio-select", RadioSelectController)

import SelfieCaptureController from "./selfie_capture_controller"
application.register("selfie-capture", SelfieCaptureController)

import ZoneLimitController from "./zone_limit_controller"
application.register("zone-limit", ZoneLimitController)

import PhoneInputController from "./phone_input_controller"
application.register("phone-input", PhoneInputController)

import SettingsTabsController from "./settings_tabs_controller"
application.register("settings-tabs", SettingsTabsController)

import ColorPickerController from "./color_picker_controller"
application.register("color-picker", ColorPickerController)

import SearchableSelectController from "./searchable_select_controller"
application.register("searchable-select", SearchableSelectController)

import SupportUserPickerController from "./support_user_picker_controller"
application.register("support-user-picker", SupportUserPickerController)
